import { replayPublicUrl } from './replayPrivacy';

// Once a visitor reaches an excluded route, Replay stays off until page reload.
let stopped = false;
let stop: (() => void) | undefined;

export function replayRouteAllowed(path: string): boolean {
  return replayPublicUrl(path, 'https://scaledtech.consulting') !== null;
}

export function replayIsStopped(): boolean {
  return stopped;
}

export function registerReplayStop(callback: () => void): void {
  if (stopped) callback();
  else stop = callback;
}

export function stopReplayOnExcludedRoute(path: string): void {
  if (replayRouteAllowed(path) || stopped) return;
  stopped = true;
  stop?.();
}
